<template>
  <Accordion
    :preopen="preopen"
    :has_opener="false"
    class="fshr-globalFilterAccordion"
    id="globalfilter"
  >
    <template v-slot:content>
      <div class="fshr-globalFilter">
        <div class="fshr-dataLoading bigloader" v-show="loading"></div>
        <div class="grd-container">
          <div
            class="fshr-globalMainFilter-wrapper"
            v-if="filter_current_settings !== null"
          >
            <main-filter
              v-model="filter_current_settings"
              :translations="translations"
              @season="changeSeason($event)"
              @completeFilter="completeFilter"
              :save_old_values="saveOldValues"
              ref="globalFilter"
            ></main-filter>

          </div>
        </div>
      </div>
    </template>
  </Accordion>
</template>

<script>

import filter_settings_winter_json from "./props/filter_settings_winter.json";
import filter_settings_summer_json from "./props/filter_settings_summer.json";
import translations_globalfilter from "./props/translations_globalfilter.json";

export default {
  name: "global-filter",
  components: {
    MainFilter: () => import("./MainFilter"),
    Accordion: () => import("./Accordion"),
  },
  data: function () {
    return {
      filter_current_settings_winter: null,
      filter_current_settings_summer: null,
      filter_current_settings: null,
      current_season: 0,
      saveOldValues: 0,
      loading: false,
    };
  },
  mounted: function () {
    this.setupFilter();
  },
  methods: {
    completeFilter: function() {
      this.setLoading();
      window.location.href = this.submit_link_parametrized;
    },
    setLoading: function () {
      this.loading = true;
    },
    setupFilter: function () {

        this.current_season = this.starting_season;

        let filter_settings_winter = this.deepCopy(this.filter_settings_winter);
        let calendar_winter = this.getFilter(filter_settings_winter.filters, "calendar");
        calendar_winter.value.range.start = new Date(calendar_winter.value.range.start);
        calendar_winter.value.range.end = new Date(calendar_winter.value.range.end);
        this.filter_current_settings_winter = filter_settings_winter;

        let filter_settings_summer = this.deepCopy(this.filter_settings_summer);
        let calendar_summer = this.getFilter(filter_settings_summer.filters, "calendar");
        calendar_summer.value.range.start = new Date(calendar_summer.value.range.start);
        calendar_summer.value.range.end = new Date(calendar_summer.value.range.end);
        this.filter_current_settings_summer = filter_settings_summer;

        this.setDataForFilterBasedOnSeason();
    },
    changeSeason: function (season) {
      if(season.value !== this.current_season){
        this.current_season = season.value;
        this.setDataForFilterBasedOnSeason();
        this.saveOldValues++;
      }
    },
    setDataForFilterBasedOnSeason(){
      if(this.current_season === 0){
        if(this.filter_current_settings !== null){
          this.filter_current_settings_summer = this.revitalizeDate(this.deepCopy(this.filter_current_settings));
        }
        this.filter_current_settings = this.revitalizeDate(this.deepCopy(this.filter_current_settings_winter));
      }else{
        if(this.filter_current_settings !== null) {
          this.filter_current_settings_winter = this.revitalizeDate(this.deepCopy(this.filter_current_settings));
        }
        this.filter_current_settings = this.revitalizeDate(this.deepCopy(this.filter_current_settings_summer));

      }
    }
  },
  computed: {
    getFormData: function () {
      return JSON.stringify(this.filter_current_settings);
    },
    submit_link_parametrized: function (){
      // Sezóna
      let submit_link = this.getFilter(this.filter_current_settings.filters, "season").value.value === 0 ? this.submit_link_winter : this.submit_link_summer;

      let zajezdy = 1;

      let dop=false;
      if(this.getFilter(this.filter_current_settings.filters, "transport")){
        // Doprava
        dop = this.getFilter(this.filter_current_settings.filters, "transport").value.value;
      }

      // Počet nocí zájezdu
      let PocetNociZajezdu = this.getFilter(this.filter_current_settings.filters, "calendar").value.nights;
      PocetNociZajezdu = PocetNociZajezdu.reduce(function (acc, val){
        acc.push(val.value);
        return acc;
      }, []);
      PocetNociZajezdu = '[' + PocetNociZajezdu.join(",") + ']';

      // Termín od
      let TerminOd = this.$moment(this.getFilter(this.filter_current_settings.filters, "calendar").value.range.start).format("YYYY-MM-DD");

      // Termín od
      let TerminDo = this.$moment(this.getFilter(this.filter_current_settings.filters, "calendar").value.range.end).format("YYYY-MM-DD");

      // Stravování
      let Stravovani = this.getFilter(this.filter_current_settings.filters, "eating").value.value;

      // Destinace
      let destinace = this.getFilter(this.filter_current_settings.filters, "destination").value;
      destinace = destinace.reduce(function (acc, item) {
        acc.push(item + "=" + 1);
        return acc;
      },[]);
      destinace = destinace.join("&");

      // Počet osob
      let pocetos = this.getFilter(this.filter_current_settings.filters, "persons").value;
      let pokoje = {};
      if(pocetos.group === null || !pocetos.hasOwnProperty("group")){
        pokoje = pocetos.rooms;
      }else{
        pokoje = pocetos.group.rooms;
      }

      pokoje = pokoje.reduce((acc, item, itemindex) => {
        acc.push('s-pocet-osob-'+itemindex+"="+item.adults);
        if(item.kids.length > 0){
          acc.push('s-pocet-deti-'+itemindex+"="+item.kids.length);
        }else{
          acc.push('s-pocet-deti-'+itemindex+"=0");
        }

        for(let i = 0; i < item.kids.length; i++){
          let vek = item.kids[i].value ?? item.kids[i];
          acc.push("s-pocet-deti-" + itemindex + "-vek-" + (i+1) + "=" + vek);
        }

        return acc;
      }, []);

      if(pocetos.count !== 0){
        pokoje.push("PocetZaSkupinu=" + pocetos.count);
      }

      pokoje = pokoje.join("&");

      let retval =  submit_link + '?zajezdy=' + zajezdy;
      if(dop !== false){
        retval += '&dop=' + dop;
      }
      retval += '&PocetNociZajezdu=' + PocetNociZajezdu
      retval += '&TerminOd=' + TerminOd;
      retval += '&TerminDo=' + TerminDo;
      retval += '&Stravovani=' + Stravovani;
      retval += '&' + destinace;
      retval += '&' + pokoje;

      console.log(retval);
      return retval;
    }
  },
  provide() {
    return {
      available_countries: this.available_countries,
      language: this.language,
    };
  },
  props: {
    submit_link_winter: {
      type: String,
      default: "/global-filter.php",
      required: false,
    },
    submit_link_summer: {
      type: String,
      default: "/global-filter.php",
      required: false,
    },
    language: {
      type: String,
      default: "cs",
    },
    starting_season: {
      default: 1,
      type: Number,
      required: false,
    },
    filter_settings_winter: {
      required: false,
      type: Object,
      default: function () {
        return filter_settings_winter_json;
      },
    },
    filter_settings_summer: {
      required: false,
      type: Object,
      default: function () {
        return filter_settings_summer_json;
      },
    },
    translations: {
      required: false,
      default: function () {
        return translations_globalfilter;
      },
      type: Object,
    },
    preopen: {
      required: false,
      default: true,
      type: Boolean
    }
  },
};
</script>

<style lang="less">
  @import "../../../Content/css/module-global-filter.less";
</style>
